import type { SVGProps } from 'react';

/** Figma: Discovery — credit-card check (21125:166089) */
const AutomaticPayments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    fill="none"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M25.625 15.625V8.75C25.625 7.3693 24.5057 6.25 23.125 6.25H3.125C1.7443 6.25 0.625 7.3693 0.625 8.75V21.25C0.625 22.6307 1.7443 23.75 3.125 23.75H15.625M0.625 12.5H25.625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.375 18.75L22.5 25.625L19.375 22.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AutomaticPayments;
